export const GTM_ID = process.env.NEXT_PUBLIC_GTM_ID ?? false;
